import { render, staticRenderFns } from "./PricingStandard.vue?vue&type=template&id=1578583a&scoped=true&"
var script = {}
import style0 from "./PricingStandard.vue?vue&type=style&index=0&id=1578583a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578583a",
  null
  
)

export default component.exports